<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Motivos para exclusão')"
        centered
        @hidden="cancelar"
        id="modal-excluir-familia"
    >
        <form @submit.prevent="submit">
            <div class="row">
                <form-radio v-model="motivo" :itens="motivos" />
            </div>

            <div class="row border-top mx-0" v-if="motivo != ''">
                <h3>{{ getTitleMotivo(motivo, motivos) }}</h3>
            </div>
            <div class="row mx-0" v-if="motivo == 1">
                <form-radio
                    class="px-0"
                    v-model="falecimento"
                    :itens="tipos_falecimento"
                />
            </div>
            <div class="row" v-if="falecimento == 'a'">
                <label class="ml-0 col-12">
                    Preencha abaixo as informações da certidão de óbito
                </label>
            </div>
            <div
                v-if="falecimento == 'a'"
                class="card border position-relative"
            >
                <div
                    class="row card-body px-2"
                    v-for="(familiar, index) in familiares"
                    :key="index"
                >
                    <h5 class="col-12 mx-0" v-html="familiar.value"></h5>
                    <form-calendar
                        :required="true"
                        grid="4"
                        v-model="obito_data_emissao[index]"
                        label="Data de emissão"
                    />
                    <form-input
                        :required="true"
                        grid="4"
                        v-model="obito_numero_termo[index]"
                        label="Número do termo"
                    />
                    <form-input
                        :required="true"
                        grid="4"
                        v-model="obito_livro[index]"
                        label="Livro"
                    />
                    <form-input
                        :required="true"
                        grid="4"
                        v-model="obito_folha[index]"
                        label="Folha"
                    />
                    <form-select
                        grid="4"
                        v-model="obito_uf[index]"
                        label="Estado"
                        :required="true"
                        @change="changeMunicipios(obito_uf[index], index)"
                        :itens="$root.arrays.estados"
                    />
                    <form-select
                        grid="4"
                        v-model="obito_municipio[index]"
                        label="Município"
                        :required="true"
                        :loading="loadingMunicipios[index]"
                        :itens="municipios"
                    />
                    <form-input
                        v-model="obito_nome_cartorio[index]"
                        label="Nome do cartório"
                    />
                </div>
            </div>
            <div
                class="card border position-relative"
                v-if="falecimento == 'b'"
            >
                <label class="ml-0 col-12">Complemento do motivo</label>

                <div
                    class="row card-body px-2"
                    v-for="(familiar, index) in familiares"
                    :key="index"
                >
                    <h5 class="col-12 mx-0" v-html="familiar.value"></h5>
                    <!-- <form-select
                    v-if="falecimento == 'b'"
                    v-model="parecer_pessoa"
                    :itens="familiares"
                    label="Selecione pessoa da família"
                /> -->
                    <form-input
                        :required="true"
                        grid="6"
                        v-model="parecer_numero[index]"
                        label="Número do parecer"
                    />
                    <form-input
                        grid="6"
                        :required="true"
                        v-model="parecer_cpf_servidor[index]"
                        label="CPF do Servidor"
                    />
                    <form-input
                        v-model="parecer_nome_servidor[index]"
                        :required="true"
                        label="Nome do Servidor"
                    />
                    <form-calendar
                        grid="4"
                        v-model="parecer_data_emissao[index]"
                        :required="true"
                        label="Data de emissão"
                    />
                    <form-select
                        grid="4"
                        v-model="parecer_uf[index]"
                        label="Estado"
                        :required="true"
                        @change="changeMunicipios(parecer_uf[index], index)"
                        :itens="$root.arrays.estados"
                    />
                    <form-select
                        grid="4"
                        v-model="parecer_municipio[index]"
                        label="Município"
                        :required="true"
                        :loading="loadingMunicipios[index]"
                        :itens="municipios"
                    />
                </div>
            </div>
            <div class="row" v-if="motivo == 2 || motivo == 3 || motivo == 8">
                <label class="ml-0 col-12">Complemento do motivo</label>
                <form-input
                    :required="true"
                    grid="6"
                    v-model="parecer_numero"
                    label="Número do parecer"
                />
                <form-input
                    grid="6"
                    :required="true"
                    v-model="parecer_cpf_servidor"
                    label="CPF do Servidor"
                />
                <form-input
                    v-model="parecer_nome_servidor"
                    :required="true"
                    label="Nome do Servidor"
                />
                <form-calendar
                    grid="4"
                    v-model="parecer_data_emissao"
                    :required="true"
                    label="Data de emissão"
                />
                <form-select
                    grid="4"
                    v-model="parecer_uf"
                    label="Estado"
                    :required="true"
                    @change="changeMunicipios(parecer_uf)"
                    :itens="$root.arrays.estados"
                />
                <form-select
                    grid="4"
                    v-model="parecer_municipio"
                    label="Município"
                    :required="true"
                    :loading="loadingCidades"
                    :itens="municipios"
                />
            </div>
            <div
                class="row mx-0"
                v-if="motivo == 4 || motivo == 5 || motivo == 6 || motivo == 7"
            >
                <form-textarea
                    :required="true"
                    class="px-0"
                    v-model="descricao"
                    label="Complemento do motivo"
                />
            </div>
            <div
                class="row mt-3"
                v-if="(motivo == 1 && falecimento) || motivo > 1"
            >
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-success" type="submit">
                        <i class="mdi mdi-check-circle"></i> Concluir
                    </button>
                    <button class="btn btn-danger" @click="cancelar">
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            loading: false,
            motivo: "",
            familiares: [],
            motivos: [
                { id: 1, value: "Falecimento de toda familia" },
                { id: 2, value: "Recusa da família em prestar informações" },
                {
                    id: 3,
                    value:
                        "Comprovação de omissão de informações ou prestação de informação inverídicas pela familia"
                },
                { id: 4, value: "Solicitação da familia" },
                { id: 5, value: "Decisão judicial" },
                {
                    id: 6,
                    value: "Familia não localizada para atualização/revalidação"
                },
                {
                    id: 7,
                    value:
                        "Familia com renda per capita acima de 1/2(meio) salário mínimo e renda familiar acima de 3 salários mínimos e que não esteja vinculada a nenhum programa social"
                },
                { id: 8, value: "Averiguação - Suspeita de Fraude" }
            ],
            falecimento: "",
            tipos_falecimento: [
                { id: "a", value: "Certidão de Óbito" },
                {
                    id: "b",
                    value: "Parecer da gestão municipal do cadastro único"
                }
            ],
            parecer_pessoa: "",
            obito_pessoa: "",
            obito_data_emissao: null,
            obito_numero_termo: null,
            obito_livro: null,
            obito_folha: null,
            obito_uf: null,
            obito_municipio: null,
            obito_nome_cartorio: null,
            parecer_numero: null,
            parecer_data_emissao: null,
            parecer_cpf_servidor: null,
            parecer_nome_servidor: null,
            parecer_uf: null,
            parecer_municipio: null,
            descricao: "",
            municipios: [],
            loadingMunicipios: [],
            loadingCidades: false
        };
    },
    watch: {
        motivo() {
            let motivo = this.motivo;
            Object.assign(this.$data, this.$options.data.call(this));
            this.motivo = motivo;

            if (motivo == 1) {
                this.obito_data_emissao = [];
                this.obito_numero_termo = [];
                this.obito_livro = [];
                this.obito_folha = [];
                this.obito_uf = [];
                this.obito_municipio = [];
                this.obito_nome_cartorio = [];
                this.parecer_numero = [];
                this.parecer_data_emissao = [];
                this.parecer_cpf_servidor = [];
                this.parecer_nome_servidor = [];
                this.parecer_uf = [];
                this.parecer_municipio = [];
            }
            this.getFamiliares();
        }
    },
    // beforeMount(){this.getFamiliares()},
    methods: {
        getTitleMotivo(motivo, motivos) {
            const result = motivos.filter(item => item.id == motivo);
            return result[0] ? result[0].value : "";
        },
        getFamiliares() {
            const result = this.item.familiares.filter(
                elem =>
                    // parseInt(elem.posicao_familiar) > 1 &&
                    parseInt(elem.estado_cadastral_cadunico) == 3 ||
                    parseInt(elem.estado_cadastral_cadunico) == 1
            );

            this.familiares = result.map(elem => ({
                id: elem.id,
                searchTerms: [elem?.nome_completo, elem?.nome_social],
                value: elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>"
            }));
        },
        submit() {
            // this.msn = null;
            // if (
            //     this.motivo == 1 &&
            //     (this.obito_data_emissao.length < this.familiares.length ||
            //         this.parecer_data_emissao.length < this.familiares.length)
            // ) {
            //     this.msn =
            //         "É necessário preencher os dados de todos os familiares.";
            // } else {
            //     this.obito_data_emissao = this.removerUndefined(
            //         this.obito_data_emissao
            //     );
            //     this.obito_numero_termo = this.removerUndefined(
            //         this.obito_numero_termo
            //     );
            //     this.obito_livro = this.removerUndefined(this.obito_livro);
            //     this.obito_folha = this.removerUndefined(this.obito_folha);
            //     this.obito_uf = this.removerUndefined(this.obito_uf);
            //     this.obito_municipio = this.removerUndefined(
            //         this.obito_municipio
            //     );
            //     this.obito_nome_cartorio = this.removerUndefined(
            //         this.obito_nome_cartorio
            //     );

            //     this.parecer_numero = this.removerUndefined(
            //         this.parecer_numero
            //     );
            //     this.parecer_data_emissao = this.removerUndefined(
            //         this.parecer_data_emissao
            //     );
            //     this.parecer_cpf_servidor = this.removerUndefined(
            //         this.parecer_cpf_servidor
            //     );
            //     this.parecer_nome_servidor = this.removerUndefined(
            //         this.parecer_nome_servidor
            //     );
            //     this.parecer_uf = this.removerUndefined(this.parecer_uf);
            //     this.parecer_municipio = this.removerUndefined(
            //         this.parecer_municipio
            //     );

            this.loading = true;
            axios
                .post("api/dashboard/familia/excluir", {
                    familia_id: this.item.id,
                    familiares: this.familiares,
                    motivo: this.motivo,
                    falecimento: this.falecimento,
                    obito_data_emissao: this.obito_data_emissao,
                    obito_numero_termo: this.obito_numero_termo,
                    obito_livro: this.obito_livro,
                    obito_folha: this.obito_folha,
                    obito_uf: this.obito_uf,
                    obito_municipio: this.obito_municipio,
                    obito_nome_cartorio: this.obito_nome_cartorio,
                    parecer_numero: this.parecer_numero,
                    parecer_data_emissao: this.parecer_data_emissao,
                    parecer_cpf_servidor: this.parecer_cpf_servidor,
                    parecer_nome_servidor: this.parecer_nome_servidor,
                    parecer_uf: this.parecer_uf,
                    parecer_municipio: this.parecer_municipio,
                    descricao: this.descricao
                })
                .then(response => {
                    this.$snack.success({
                        button: false,
                        text: "Usuário excluído com sucesso."
                    });
                    this.$emit("reload");
                    this.cancelar();
                });
            // }
        },
        removerUndefined(array) {
            if (Array.isArray(array)) {
                if (array != null && array != []) {
                    return array.filter(elem => elem != undefined);
                } else {
                    return null;
                }
            } else {
                return array == [] ? null : array;
            }
        },
        changeMunicipios(uf, index = null) {
            this.loadingMunicipios[index] = true;
            index != null
                ? (this.loadingCidades = true)
                : (this.loadingCidades = false);
            axios
                .get("api/dashboard/enderecos/get/cidades/" + uf)
                .then(response => {
                    this.municipios = response.data;
                    this.loadingMunicipios[index] = false;
                    this.loadingCidades = false;
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("modal-excluir-familia");
        }
    }
};
</script>
